export default "__VITE_ASSET__p77k0VK$__"